import React from 'react';

export default function ImportanceBadge({ tier }) {
  const labels = {
    critical: 'Critical',
    important: 'Important',
    routine: 'Routine',
    low: 'Low',
  };
  return (
    <span className={`importance-badge ${tier}`}>
      {labels[tier] || tier}
    </span>
  );
}
